import { Asset } from '@/api/generatedApi';
import { useMatchLink } from '@/hooks/useMatchLink';
import { useSearchFilters } from '@/hooks/useSearchFilters';
import { AssetPageObjectModel } from '@/poms/assetPageObjectModel';
import { Button, IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { MatchIcon } from '../AssetsPage/MatchIcon';

export const FindMatchesButton = ({
  asset,
  variant,
  minThreshold,
}: {
  asset: Asset;
  variant?: 'button' | 'icon';
  minThreshold?: number;
}) => {
  const linkTo = useMatchLink(asset, minThreshold);
  const { assetId: searchAssetId } = useSearchFilters();
  const isDisabled = asset.id === searchAssetId;

  if (!linkTo) {
    return;
  }

  const tooltipTitle = isDisabled ? undefined : 'Find Matches';
  const testId = AssetPageObjectModel.FindMatchesButton;

  const buttonElement =
    variant === 'icon' ? (
      <IconButton size='small' disabled={isDisabled} data-testid={isDisabled ? testId : undefined}>
        <MatchIcon />
      </IconButton>
    ) : (
      <Button
        variant='text'
        size='small'
        color='primary'
        startIcon={<MatchIcon />}
        disabled={isDisabled}
        data-testid={isDisabled ? testId : undefined}
      >
        Find Matches
      </Button>
    );

  const wrappedButton = isDisabled ? (
    buttonElement
  ) : (
    <Link to={linkTo} data-testid={testId}>
      {buttonElement}
    </Link>
  );

  if (variant === 'icon') {
    return (
      <Tooltip title={tooltipTitle}>
        <span>{wrappedButton}</span>
      </Tooltip>
    );
  }

  return wrappedButton;
};
